import { gql } from '@apollo/client';
import { PartnerLocationInfoShared } from '../fragments';

export default gql`
  query partnerLocation($id: ID) {
    partnerLocation(id: $id) {
      ...PartnerLocationInfoShared
    }
  }
  ${PartnerLocationInfoShared}
`;
